var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumerUnit02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{font-family:'MyriadPro-Regular';}\n\t.st2{font-size:3.2468px;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4.5,
    className: "st0",
    width: 10,
    height: 7.1
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 6.0042 9.4302)",
    className: "st1 st2"
  }, "CU"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumerUnit02);
export default __webpack_public_path__ + "static/media/ConsumerUnit-02.b8868c561e5aa7612375c857b2626cc8.svg";
export { ForwardRef as ReactComponent };